<template>
  <div class="watermark-container">
    <div v-for="(item, index) in watermarks" :key="index" class="watermark-text" :style="{ width: `${itemSize.w}px`, height: `${itemSize.h}px` }">
      <div v-if="config.showIndex.includes(index)" class="watermark-rotate">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    config: {
      type: Object,
      default: () => {
        return {
          colums: 3,
          rows: 3,
          showIndex: [0, 4, 8]
        }
      }
    }
  },
  data() {
    return {
      watermarks: Array(this.config.rows * this.config.colums).fill(null),
      itemSize: {
        w: 0,
        h: 0
      }
    }
  },
  mounted() {
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const itemSize = {
      w: Math.floor(windowWidth / this.config.colums),
      h: Math.floor(windowHeight / this.config.rows)
    }
    this.itemSize = itemSize
  }
}
</script>

<style lang="scss">
.watermark-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: none;
  overflow: hidden;
}
.watermark-text {
  font-size: 16px;
  line-height: 26px;
  height: 24px;
  white-space: nowrap;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;

  .watermark-rotate {
    display: inline-block;
    color: rgba(0, 0, 0, 0.1);
    transform: rotateZ(-35deg);
    -webkit-transform: rotateZ(-35deg);
  }
}
</style>
